<template>
  <!-- 15-1医疗机构案件进展情况详情页面 -->
  <div class="main-css">
    <!-- 主要信息部分 -->
    <div class="main-box">
      <!-- 左边 -->
      <div class="left-box">
        <!-- 左边button部分 -->
        <!-- 主要信息部分 -->
        <div class="main-left-box">
          <div class="top-title">
            <div class="case-num">
              {{ $t("educationalInstitution") }} {{ infoList.educationName }}
            </div>
            <div class="case-num">
              {{ $t("talentNumber") }} {{ infoList.resumeId }}
            </div>
          </div>
          <!-- 显示图片 -->
          <div class="case-img">
            <div class="one-box-left1">
              <img
                @error="
                  e => {
                    e.target.src = require('@/assets/avatar.png');
                  }
                "
                :src="urlImgInfo"
                alt=""
              />
            </div>
            <div class="one-box-left2">
              <div class="one-box-left-line1">
                <div class="one-box-left-line-smallleft">
                  <p></p>
                </div>
                <div class="one-box-left-line-smallright">
                  <p>{{ infoList.anonym }}</p>
                </div>
              </div>
              <div class="one-box-left-line2">
                <div class="one-box-left-line-smallleft">
                  <p>{{ $t("citizen") }}</p>
                </div>
                <div class="one-box-left-line-smallright">
                  <p>{{ infoList.name }}</p>
                </div>
              </div>
              <div class="one-box-left-line3">
                <div class="one-box-left-line-smallleft">
                  <p>{{ $t("sex") }}</p>
                </div>
                <div class="one-box-left-line-smallright">
                  <p>
                    {{
                      language === "CN"
                        ? infoList.sex_dictText
                        : infoList.jpsex_dictText
                    }}
                  </p>
                </div>
              </div>
              <div class="one-box-left-line4">
                <div class="one-box-left-line-smallleft">
                  <p>{{ $t("birthDay") }}</p>
                </div>
                <div class="one-box-left-line-smallright">
                  <p v-if="infoList.birth">
                    {{ infoList.birth.split(" ")[0] }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- 标签部分 -->
          <div class="label">
            <div :class="label1 ? 'label-box-active' : 'label-box'">
              {{ $t("goodAtJapanese") }}
              <span>×</span>
            </div>
            <div :class="label2 ? 'label-box-active' : 'label-box'">
              {{ $t("qualified") }}
              <span>×</span>
            </div>
            <div :class="label3 ? 'label-box-active' : 'label-box'">
              {{ $t("interviewAtAnytime") }}
              <span>×</span>
            </div>
            <div :class="label4 ? 'label-box-active' : 'label-box'">
              {{ $t("determined") }}
              <span>×</span>
            </div>
          </div>
          <!-- 第一行 -->
          <div class="inline-box">
            <div class="inline-left">
              <div class="inline-left-title">{{ $t("contactAddress") }}</div>
              <div class="inline-left-title-main">
                {{ $t("currentAddress") }}
                <el-tooltip
                  :content="infoList.address"
                  placement="top"
                  :disabled="
                    String(infoList.address).length > 10 ? false : true
                  "
                >
                  <div class="inline-left-title-main-right">
                    {{ infoList.address }}
                  </div>
                </el-tooltip>
              </div>

              <div class="inline-left-title-main">
                {{ $t("email") }}
                <el-tooltip
                  :content="infoList.email"
                  placement="top"
                  :disabled="
                    String(infoList.email).length > 10 ? false : true
                  "
                >
                  <div class="inline-left-title-main-right">
                    {{ infoList.email }}
                  </div>
                </el-tooltip>
                <!-- <div class="inline-left-title-main-right">
                  {{ infoList.email }}
                </div> -->
              </div>

              <div class="inline-left-title-main">
                {{ $t("telephoneNumber") }}
                <el-tooltip
                  :content="infoList.telephone"
                  placement="top"
                  :disabled="
                    String(infoList.telephone).length > 10 ? false : true
                  "
                >
                  <div class="inline-left-title-main-right">
                    {{ infoList.telephone }}
                  </div>
                </el-tooltip>
                <!-- <div class="inline-left-title-main-right">
                  {{ infoList.telephone }}
                </div> -->
              </div>
            </div>
            <div class="inline-right">
              <div class="inline-left-title">{{ $t("education") }}</div>

              <div class="inline-left-title-main">
                {{ $t("period") }}
                   <el-tooltip
                  :content="infoList.enrollment.split(' ')[0] + ' ' + infoList.graduation.split(' ')[0] "
                  placement="top"
                  :disabled="
                    String(infoList.enrollment).length > 5 ? false : true
                  "
                >
                <div
                  class="inline-left-title-main-right"
                  v-if="infoList.enrollment && infoList.graduation"
                >
                  {{ infoList.enrollment.split(" ")[0] }}
                  {{ infoList.graduation.split(" ")[0] }}
                </div>
                  </el-tooltip>
              </div>

              <div class="inline-left-title-main">
                {{ $t("school") }}
                <el-tooltip
                  :content="infoList.school"
                  placement="top"
                  :disabled="String(infoList.school).length > 10 ? false : true"
                >
                  <div class="inline-left-title-main-right">
                    {{ infoList.school }}
                  </div>
                </el-tooltip>
                <!-- <div class="inline-left-title-main-right">
                  {{ infoList.school }}
                </div> -->
              </div>

              <div class="inline-left-title-main">
                {{ $t("major") }}
                <el-tooltip
                  :content="infoList.profession"
                  placement="top"
                  :disabled="
                    String(infoList.profession).length > 10 ? false : true
                  "
                >
                  <div class="inline-left-title-main-right">
                    {{ infoList.profession }}
                  </div>
                </el-tooltip>
                <!-- <div class="inline-left-title-main-right">
                  {{ infoList.profession }}
                </div> -->
              </div>
            </div>
          </div>
          <!-- 第二行 -->
          <div class="inline-box">
            <div class="inline-left">
              <div class="inline-left-title">{{ $t("qualification") }}</div>
              <div class="inline-left-title-main">
                {{ $t("qualification1") }}
                <el-tooltip
                  :content="infoList.qualification1"
                  placement="top"
                  :disabled="
                    String(infoList.qualification1).length > 10 ? false : true
                  "
                >
                  <div class="inline-left-title-main-right">
                    {{ infoList.qualification1 }}
                  </div>
                </el-tooltip>
                <!-- <div class="inline-left-title-main-right">
                  {{infoList.qualification1}}
                </div> -->
              </div>

              <div class="inline-left-title-main">
                {{ $t("qualification2") }}
                <el-tooltip
                  :content="infoList.qualification2"
                  placement="top"
                  :disabled="
                    String(infoList.qualification2).length > 10 ? false : true
                  "
                >
                  <div class="inline-left-title-main-right">
                    {{ infoList.qualification2 }}
                  </div>
                </el-tooltip>
                <!-- <div class="inline-left-title-main-right">
                  {{infoList.qualification2}}
                </div> -->
              </div>

              <div class="inline-left-title-main">
                {{ $t("qualification3") }}
                <el-tooltip
                  :content="infoList.qualification3"
                  placement="top"
                  :disabled="
                    String(infoList.qualification3).length > 10 ? false : true
                  "
                >
                  <div class="inline-left-title-main-right">
                    {{ infoList.qualification3 }}
                  </div>
                </el-tooltip>
                <!-- <div class="inline-left-title-main-right">
                  {{infoList.qualification3}}
                </div> -->
              </div>
            </div>
            <div class="inline-right">
              <div class="inline-left-title">{{ $t("workHistory") }}</div>

              <div class="inline-left-title-main">
                {{ $t("period") }}
                   <el-tooltip
                  :content="infoList.enrollment.split(' ')[0] + ' ' + infoList.graduation.split(' ')[0] "
                  placement="top"
                  :disabled="
                    String(infoList.enrollment).length > 5 ? false : true
                  "
                >
                <div
                  class="inline-left-title-main-right"
                  v-if="infoList.startYear && infoList.endYear"
                >
                  {{ infoList.enrollment.split(" ")[0] }}
                  {{ infoList.graduation.split(" ")[0] }}
                </div>
                  </el-tooltip>
              </div>

              <div class="inline-left-title-main">
                {{ $t("school") }}
                <el-tooltip
                  :content="infoList.workPlace"
                  placement="top"
                  :disabled="
                    String(infoList.workPlace).length > 10 ? false : true
                  "
                >
                  <div class="inline-left-title-main-right">
                    {{ infoList.workPlace }}
                  </div>
                </el-tooltip>
                <!-- <div class="inline-left-title-main-right">
                  {{infoList.workPlace}}
                </div> -->
              </div>

              <div class="inline-left-title-main">
                {{ $t("belongs") }}
                <el-tooltip
                  :content="infoList.type"
                  placement="top"
                  :disabled="String(infoList.type).length > 10 ? false : true"
                >
                  <div class="inline-left-title-main-right">
                    {{ infoList.type }}
                  </div>
                </el-tooltip>
                <!-- <div class="inline-left-title-main-right">
                  {{ infoList.type }}
                </div> -->
              </div>
            </div>
          </div>
          <!-- 第三行 -->
          <div class="inline-box">
            <div class="inline-left">
              <div class="inline-left-title">{{ $t("languageSkills") }}</div>
              <div class="inline-left-title-main">
                {{ $t("japanese") }}
                <el-tooltip
                  :content="
                    language === 'CN'
                      ? infoList.japanese_dictText
                      : infoList.jpjapanese_dictText
                  "
                  placement="top"
                  :disabled="
                    String(
                      language === 'CN'
                        ? infoList.japanese_dictText
                        : infoList.jpjapanese_dictText
                    ).length > 10
                      ? false
                      : true
                  "
                >
                  <div class="inline-left-title-main-right">
                    {{
                      language === "CN"
                        ? infoList.japanese_dictText
                        : infoList.jpjapanese_dictText
                    }}
                  </div>
                </el-tooltip>
                <!-- <div class="inline-left-title-main-right">
                  {{language==='CN'?infoList.japanese_dictText:infoList.jpjapanese_dictText}}
                </div> -->
              </div>

              <div class="inline-left-title-main">
                {{ $t("english") }}
                <el-tooltip
                  :content="
                    language === 'CN'
                      ? infoList.english_dictText
                      : infoList.jpenglish_dictText
                  "
                  placement="top"
                  :disabled="
                    String(
                      language === 'CN'
                        ? infoList.english_dictText
                        : infoList.jpenglish_dictText
                    ).length > 10
                      ? false
                      : true
                  "
                >
                  <div class="inline-left-title-main-right">
                    {{
                      language === "CN"
                        ? infoList.english_dictText
                        : infoList.jpenglish_dictText
                    }}
                  </div>
                </el-tooltip>
                <!-- <div class="inline-left-title-main-right">
                  {{language==='CN'?infoList.english_dictText:infoList.jpenglish_dictText}}
                </div> -->
              </div>

              <div class="inline-left-title-main">
                {{ $t("other") }}
                <el-tooltip
                  :content="infoList.other"
                  placement="top"
                  :disabled="String(infoList.other).length > 10 ? false : true"
                >
                  <div class="inline-left-title-main-right">
                    {{ infoList.other }}
                  </div>
                </el-tooltip>
                <!-- <div class="inline-left-title-main-right">
                  {{ infoList.other }}
                </div> -->
              </div>
            </div>
            <div class="inline-right">
              <div class="inline-left-title">{{ $t("request") }}</div>

              <div class="inline-left-title-main">
                {{ $t("joiningCompany") }}
                    <el-tooltip
                  :content="infoList.startYear.split(' ')[0] + ' ' + infoList.endYear.split(' ')[0] "
                  placement="top"
                  :disabled="
                    String(infoList.enrollment).length > 5 ? false : true
                  "
                >
                <div
                  class="inline-left-title-main-right"
                  v-if="infoList.startYear && infoList.endYear"
                >
                  {{ infoList.startYear.split(" ")[0] }}
                  {{ infoList.endYear.split(" ")[0] }}
                </div>
                  </el-tooltip>
              </div>

              <div class="inline-left-title-main">
                {{ $t("workLocation") }}
                <el-tooltip
                  :content="infoList.workPlace"
                  placement="top"
                  :disabled="
                    String(infoList.workPlace).length > 10 ? false : true
                  "
                >
                  <div class="inline-left-title-main-right">
                    {{ infoList.workPlace }}
                  </div>
                </el-tooltip>
                <!-- <div class="inline-left-title-main-right">
                  {{ infoList.workPlace }}
                </div> -->
              </div>

              <div class="inline-left-title-main">
                {{ $t("occupation") }}
                <el-tooltip
                  :content="
                    language === 'CN'
                      ? infoList.hopeWorktype_dictText
                      : infoList.jphopeWorktype_dictText
                  "
                  placement="top"
                  :disabled="
                    String(
                      language === 'CN'
                        ? infoList.hopeWorktype_dictText
                        : infoList.jphopeWorktype_dictText
                    ).length > 10
                      ? false
                      : true
                  "
                >
                  <div class="inline-left-title-main-right">
                    {{
                      language === "CN"
                        ? infoList.hopeWorktype_dictText
                        : infoList.jphopeWorktype_dictText
                    }}
                  </div>
                </el-tooltip>
                <!-- <div class="inline-left-title-main-right">
                  {{language==="CN"?infoList.hopeWorktype_dictText:infoList.jphopeWorktype_dictText}}
                </div> -->
              </div>
            </div>
          </div>

          <!-- 第五行 -->
          <div class="inline-log-box">
            <div class="long-box-title">{{ $t("selfPR") }}</div>
            <div class="long-box-main">
              {{ infoList.pr }}
            </div>
          </div>
        </div>
      </div>
      <!-- 右边聊天部分 -->
      <div class="right-box">
        <!-- 头部 信息显示 -->
        <div class="top-title">
          <div class="case-num">
            {{ $t("caseNumber") }} {{ infoList.jobId }}
          </div>
          <div class="case-num">
            {{ $t("recruiter") }} {{ infoList.userName }}
          </div>
          <div class="case-num">
            {{ $t("applicationDate") }}
            {{ infoList.createTime && infoList.createTime.split(" ")[0] }}
          </div>
        </div>
        <!--        信息栏-->
        <div class="info-box">
          <span class="info-box-span">{{ $t("application") }}</span>
          <div class="el-dropdown-class-normal">
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link-normal">
                {{ jobInfoListItem
                }}<img src="./assets/Vector.png" alt="" class="info-img-css2" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(item, index) in jobInfoList"
                  :key="index"
                  :command="item.jobId"
                >
                  {{ item.jobName }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <!--        进度框-->
        <div class="schedule-box">
          <span class="schedule-box-span">{{ $t("promotionStatus") }}</span>
          <!-- 第一行 进度条部分 -->
          <div class="progress-bar">
            <div
              :class="lineShow1 ? 'line-between-active' : 'line-between-normal'"
            ></div>
            <div
              :class="
                itemShow1 ? 'progress-item-active-big' : 'progress-item-normal'
              "
            >
              1<span class="progress-title">{{ $t(processText[0]) }}</span>
            </div>
            <div
              :class="lineShow2 ? 'line-center-active' : 'line-center-normal'"
            ></div>
            <div
              :class="
                itemShow2 ? 'progress-item-active-big' : 'progress-item-normal'
              "
            >
              2<span class="progress-title">{{ $t(processText[1]) }}</span>
            </div>
            <div
              :class="lineShow3 ? 'line-center-active' : 'line-center-normal'"
            ></div>

            <div
              :class="
                itemShow3 ? 'progress-item-active-big' : 'progress-item-normal'
              "
            >
              3<span class="progress-title">{{ $t(processText[2]) }}</span>
            </div>

            <div
              :class="lineShow4 ? 'line-center-active' : 'line-center-normal'"
            ></div>
            <div
              :class="
                itemShow4 ? 'progress-item-active-big' : 'progress-item-normal'
              "
            >
              4<span class="progress-title">{{ $t(processText[3]) }}</span>
            </div>
            <div
              :class="lineShow5 ? 'line-center-active' : 'line-center-normal'"
            ></div>
            <div
              :class="
                itemShow5 ? 'progress-item-active-big' : 'progress-item-normal'
              "
            >
              5<span class="progress-title">{{ $t(processText[4]) }}</span>
            </div>
            <div
              :class="lineShow6 ? 'line-center-active' : 'line-center-normal'"
            ></div>
            <div
              :class="
                itemShow6 ? 'progress-item-active-big' : 'progress-item-normal'
              "
            >
              6<span class="progress-title">{{ $t(processText[5]) }}</span>
            </div>
            <div
              :class="lineShow7 ? 'line-between-active' : 'line-between-normal'"
            ></div>
          </div>
          <!--          第二行 -->
          <div class="input-box-css">
            <div class="input-box">
              {{ $t("situationId") }}：{{ $t(mesZhuIsShow) }}
            </div>
          </div>
          <!--          第四行-->
          <div class="box-title">
            <p>
              {{ $t("applicantSide") }} ：{{
                applicantSideTimeIsShow ? applicantSideTime : ""
              }}{{ $t(applicantSide) }}
              {{ $t(applicantSideWord) }}
              {{ applicantSideCompleteIsShow ? $t("complete") : "" }}
            </p>
          </div>
          <!--          第五行-->
          <div class="box-title">
            <p>
              {{ $t("recruitmentSide") }}：{{
                recruitmentSideTimeIsShow ? recruitmentSideTime : ""
              }}
              {{ $t(recruitmentSideWord) }}
              {{ timeIsShow ? $t("complete") : "" }}
            </p>
            <div class="button-box" v-if="buttonIsShow">
              <button class="button-css1" @click="medicalApplyStatusUpdate(2)">
                {{ $t("ng") }}
              </button>
              <button class="button-css2" @click="medicalApplyStatusUpdate(1)">
                {{ $t("pass") }}
              </button>
            </div>
          </div>
        </div>
        <!--        聊天信息-->
        <div class="chat-box-css">
          <span>{{ $t("contactHistory") }}</span>
          <Socket></Socket>
        </div>
      </div>
    </div>
    <div class="main-button">
      <button @click="collect">{{ $t("collection") }}</button>
    </div>
  </div>
</template>
<script>
import Socket from "../../components/socket.vue";
import {
  resumeDetailQuery,
  getUrlFromOSS,
  getJobInfoByResumeIdAndApplyId,
  applyMedicalStatusUpdate,
  applyStatusQuery,
  getJobInfoByResumeId,
  selectResumeInfoByApplyJobId,
  insertMedicalCollection
} from "../../js/api";
import AES from "../../js/AES";

export default {
  name: "educationViewJobInformation",
  components: { Socket },
  data() {
    return {
      label1: 0,
      label2: 0,
      label3: 0,
      label4: 0,
      labelListHandle: [],
      infoList: [],
      avatarItem: "",
      urlImgInfo: "",
      applyId: "",
      jobId: "",
      resumeId: "",
      jobInfoList: [],
      jobInfoListItem: "",
      lineShow1: false,
      lineShow2: false,
      lineShow3: false,
      lineShow4: false,
      lineShow5: false,
      lineShow6: false,
      lineShow7: false,
      itemShow1: false,
      itemShow2: false,
      itemShow3: false,
      itemShow4: false,
      itemShow5: false,
      itemShow6: false,
      buttonIsShow: true,
      processText: [
        "documentScreening",
        "interview",
        "contract",
        "statusOfResidence",
        "travel",
        "joiningCompany"
      ],
      mesZhuIsShow: "",
      applicantSide: "",
      recruitmentSideTime: "",
      recruitmentSideWord: "",
      applicantSideTime: "",
      applicantSideWord: "",
      timeIsShow: false,
      timeIsShowOne: false,
      applicantSideTimeIsShow: false,
      recruitmentSideTimeIsShow: false,
      applicantSideCompleteIsShow: false,
      language: ""
    };
  },
  created() {
    //获取当前语言的值
    this.language = window.localStorage.getItem("language");
    console.log("--------路由传参888--------");
    console.log(this.$route);
    this.applyId = this.$route.query.applyId;
    this.jobId = this.$route.query.jobId;
    this.resumeId = this.$route.query.resumeId;
    this.getResumeDetailQuery();
  },
  computed: {},
   mounted() {
    window.addEventListener("setItemEvent", this.languageChange, true);
   },
     destroyed() {
    window.removeEventListener("setItemEvent", this.languageChange, true);
  },
  methods: {
    //顾名思义 应聘收藏
    collect(applyId) {
      var educationCollectAddDTO = {
        systemEventId: this.applyId,
        systemTypeId: 5,
      }
      insertMedicalCollection(educationCollectAddDTO).then((res) => {
        console.log("教育机构添加应聘案件收藏", res)
        if (res.data.code === "A0000") {
          this.$message({
            message: '收藏成功！',
            type: 'success'
          });
          this.$router.push({
            path: '/medicalInstitutionsCollectApplicationInformationList',
            name: 'medicalInstitutionsCollectApplicationInformationList',
            params: {}
          });
        } else if (res.data.code === "A0506") {
          this.$message({
            message: this.$t('thisApplicationFavorite'),
            type: 'warning'
          });
        } else {
          this.$message.error('提交错误！');
        }
      }).catch((res) => {
        console.log("教育机构添加应聘收藏接口异常", res)
      })
    },
    dataSplit(){
      return data.split(" ")[0]
    },
    //监听语言
    languageChange(e) {
      const that = this;
      console.log("------监听数据------");
      console.log(e);
      if (e.key && e.key == "language" && e.newValue) {
        that.language = e.newValue;
      }
    },
    // 人才信息详情查看接口数据
    getResumeDetailQuery() {
      var fakeInfo = {
        applyId: this.applyId
      };
      selectResumeInfoByApplyJobId(fakeInfo)
        .then(res => {
          console.log("--------人才信息详情查看接口数据--------");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.avatarItem = aesFecInfo.data[0].avatar;
            this.label1 = parseInt(aesFecInfo.data[0].label1);
            this.label2 = parseInt(aesFecInfo.data[0].label2);
            this.label3 = parseInt(aesFecInfo.data[0].label3);
            this.label4 = parseInt(aesFecInfo.data[0].label4);
            this.getUrl();
            this.byResumeIdAndApplyIdGetJobInfo();
            this.infoList = aesFecInfo.data[0];
          }
        })
        .catch(res => {
          console.log("人才信息详情查看接口异常:", res);
        });
    },

    // 头像回显
    getUrl() {
      var fakeInfo = {
        message: this.avatarItem
      };
      getUrlFromOSS(fakeInfo)
        .then(res => {
          console.log("-----------头像回显-----------");
          if (res.data.code === "200 OK") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.urlImgInfo = aesFecInfo.message;
          }
          console.log(res);
        })
        .catch(res => {
          console.log("-----------头像回显-----------");
          console.log(res);
        });
    },
    //通过人才信息和应聘信息获取案件列表接口（下拉菜单获取）
    byResumeIdAndApplyIdGetJobInfo() {
      var fakeInfo = {
        resumeId: this.resumeId
      };
      getJobInfoByResumeIdAndApplyId(fakeInfo)
        .then(res => {
          console.log("------通过人才信息和应聘信息获取案件列表接口------");
          console.log(res);
          const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
          console.log(aesFecInfo);
          this.jobInfoList = aesFecInfo.data;
          for (var i = 0; i < aesFecInfo.data.length; i++) {
            if (this.jobId === aesFecInfo.data[i].jobId) {
              this.jobInfoListItem = aesFecInfo.data[i].jobName;
              this.applyId = aesFecInfo.data[i].applyId;
              this.jobId = aesFecInfo.data[i].jobId;
              this.getApplyStatusQuery();
            }
          }
        })
        .catch(res => {
          console.log("------通过人才信息和应聘信息获取案件列表接口------");
          console.log(res);
        });
    },
    // 应聘状态查询接口
    getApplyStatusQuery() {
      this.buttonIsShow = false;
      this.mesZhuIsShow = "";
      this.applicantSide = "";
      this.applicantSideWord = "";
      this.recruitmentSideWord = "";
      this.timeIsShow = false;
      this.applicantSideTimeIsShow = false;
      this.recruitmentSideTimeIsShow = false;
      var that = this;
      var fakeInfo = {
        applyId: "",
        jobId: this.jobId,
        resumeId: this.resumeId
      };
      applyStatusQuery(fakeInfo)
        .then(res => {
          this.recruitmentSideTimeIsShow = false;
          this.applicantSideTimeIsShow = false;
          console.log("------应聘状态查询接口------");
          console.log(res);
          const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
          console.log(aesFecInfo);
          if (res.data.code === "A1055") {
            this.buttonIsShow = false;
            this.s = "medicalInstitutionsHaveOperated";
            this.applicantSide = "WaitingEducational";
            this.timeIsShow = true;
            this.recruitmentSideTimeIsShow = true;
            this.timeOpen(aesFecInfo);
            this.recruitmentSideWord = this.processText[aesFecInfo.statusName];
            this.statusNameOpen(aesFecInfo.statusName);
          } else if (res.data.code === "A0000") {
            this.buttonIsShow = true;
            this.statusNameOpen(aesFecInfo.statusName);
            if (
              aesFecInfo.educationOperate === "0" &&
              aesFecInfo.medicalOperate === "0"
            ) {
              this.timeIsShow = false;
              this.mesZhuIsShow = "waitingBothOperate";
              this.applicantSide = "WaitingEducational";
              this.recruitmentSideWord = "WaitingMedicalInstitution";
            } else if (
              aesFecInfo.educationOperate === "1" &&
              aesFecInfo.medicalOperate === "0"
            ) {
              this.mesZhuIsShow =
                "EducationalOperatedMedicalInstitutionsOperate";
              this.recruitmentSideWord = "WaitingMedicalInstitution";
              this.applicantSideWord = this.processText[aesFecInfo.statusName];
              this.applicantSideCompleteIsShow = true;
              this.timeIsShowOne = true;
              this.timeOpen(aesFecInfo);
              this.applicantSideTimeIsShow = true;
            }
          } else if (res.data.code === "A1054") {
            this.buttonIsShow = false;
            if (
              aesFecInfo.educationOperate === "1" &&
              aesFecInfo.medicalOperate === "1"
            ) {
              this.statusNameOpen(aesFecInfo.statusName);
              this.timeOpen(aesFecInfo);
              this.applicantSideTimeIsShow = true;
              this.recruitmentSideTimeIsShow = true;
              this.mesZhuIsShow = "applicationCompleted";
              this.applicantSideWord = "educationalOperationCompleted";
              this.recruitmentSideWord = "medicalOperationCompleted";
            } else if (
              aesFecInfo.educationOperate === "0" &&
              aesFecInfo.medicalOperate === "2"
            ) {
              this.statusNameOpen(aesFecInfo.statusName);
              this.applicantSideWord = "educationalNotOperating";
              this.timeOpen(aesFecInfo);
              this.recruitmentSideTimeIsShow = true;
              this.mesZhuIsShow = "operationMedicalInstitutionFailed";
              this.recruitmentSideWord = "operationMedicalInstitutionFailed";
            } else if (
              aesFecInfo.educationOperate === "1" &&
              aesFecInfo.medicalOperate === "2"
            ) {
              this.statusNameOpen(aesFecInfo.statusName);
              this.timeOpen(aesFecInfo);
              this.applicantSideTimeIsShow = true;
              this.recruitmentSideTimeIsShow = true;
              this.applicantSideWord = "educationalHavePassed";
              this.recruitmentSideWord = "operationMedicalInstitutionFailed";
              this.mesZhuIsShow = "operationMedicalInstitutionFailed";
            } else if (
              aesFecInfo.educationOperate === "2" &&
              aesFecInfo.medicalOperate === "0"
            ) {
              this.statusNameOpen(aesFecInfo.statusName);
              this.timeOpen(aesFecInfo);
              this.applicantSideTimeIsShow = true;
              this.applicantSideWord = "educationalInstitutionsFailed";
              this.recruitmentSideWord = "medicalNotOperating";
              this.mesZhuIsShow = "educationalInstitutionsFailed";
            } else if (
              aesFecInfo.educationOperate === "2" &&
              aesFecInfo.medicalOperate === "1"
            ) {
              this.statusNameOpen(aesFecInfo.statusName);
              this.timeOpen(aesFecInfo);
              this.applicantSideTimeIsShow = true;
              this.recruitmentSideTimeIsShow = true;
              this.applicantSideWord = "educationalInstitutionsFailed";
              this.recruitmentSideWord = "medicalHavePassed";
              this.mesZhuIsShow = "educationalInstitutionsFailed";
            }
          } else if (res.data.code === "A1050") {
            this.mesZhuIsShow = "adminReviewing";
            this.buttonIsShow = false;
            this.lineShow1 = false;
            this.itemShow1 = false;
            this.lineShow2 = false;
            this.itemShow2 = false;
            this.lineShow3 = false;
            this.itemShow3 = false;
            this.lineShow4 = false;
            this.itemShow4 = false;
            this.lineShow5 = false;
            this.itemShow5 = false;
            this.lineShow6 = false;
            this.itemShow6 = false;
          } else if (res.data.code === "A1051") {
            this.mesZhuIsShow = "adminFailed";
            this.buttonIsShow = false;
            this.lineShow1 = false;
            this.itemShow1 = false;
            this.lineShow2 = false;
            this.itemShow2 = false;
            this.lineShow3 = false;
            this.itemShow3 = false;
            this.lineShow4 = false;
            this.itemShow4 = false;
            this.lineShow5 = false;
            this.itemShow5 = false;
            this.lineShow6 = false;
            this.itemShow6 = false;
          }
        })
        .catch(res => {
          console.log("------应聘状态查询接口------");
          console.log(res);
        });
    },
    // 时间判断显示(需要传输 data )
    timeOpen(data) {
      if (data.statusName === 0) {
        this.applicantSideTime = data.eduSelectionStatus;
        this.recruitmentSideTime = data.medicalSelectionStatus;
      } else if (data.statusName === 1) {
        this.applicantSideTime = data.eduInterviewStatus;
        this.recruitmentSideTime = data.medicalInterviewStatus;
      } else if (data.statusName === 2) {
        this.applicantSideTime = data.eduContractReadiness;
        this.recruitmentSideTime = data.medicalContractReadiness;
      } else if (data.statusName === 3) {
        this.applicantSideTime = data.eduResidenceStatus;
        this.recruitmentSideTime = data.medicalResidenceStatus;
      } else if (data.statusName === 4) {
        this.applicantSideTime = data.eduImmigrationStatus;
        this.recruitmentSideTime = data.medicalImmigrationStatus;
      } else if (data.statusName === 5) {
        this.applicantSideTime = data.eduMembershipStatus;
        this.recruitmentSideTime = data.medicalMembershipStatus;
      }
    },
    //转态判断显示
    statusNameOpen(num) {
      if (num === 0) {
        this.lineShow1 = true;
        this.itemShow1 = true;
        this.lineShow2 = false;
        this.itemShow2 = false;
        this.lineShow3 = false;
        this.itemShow3 = false;
        this.lineShow4 = false;
        this.itemShow4 = false;
        this.lineShow5 = false;
        this.itemShow5 = false;
        this.lineShow6 = false;
        this.itemShow6 = false;
      } else if (num === 1) {
        this.lineShow1 = true;
        this.itemShow1 = true;
        this.lineShow2 = true;
        this.itemShow2 = true;
        this.lineShow3 = false;
        this.itemShow3 = false;
        this.lineShow4 = false;
        this.itemShow4 = false;
        this.lineShow5 = false;
        this.itemShow5 = false;
        this.lineShow6 = false;
        this.itemShow6 = false;
      } else if (num === 2) {
        this.lineShow1 = true;
        this.itemShow1 = true;
        this.lineShow2 = true;
        this.itemShow2 = true;
        this.lineShow3 = true;
        this.itemShow3 = true;
        this.lineShow4 = false;
        this.itemShow4 = false;
        this.lineShow5 = false;
        this.itemShow5 = false;
        this.lineShow6 = false;
        this.itemShow6 = false;
      } else if (num === 3) {
        this.lineShow1 = true;
        this.itemShow1 = true;
        this.lineShow2 = true;
        this.itemShow2 = true;
        this.lineShow3 = true;
        this.itemShow3 = true;
        this.lineShow4 = true;
        this.itemShow4 = true;
        this.lineShow5 = false;
        this.itemShow5 = false;
        this.lineShow6 = false;
        this.itemShow6 = false;
      } else if (num === 4) {
        this.lineShow1 = true;
        this.itemShow1 = true;
        this.lineShow2 = true;
        this.itemShow2 = true;
        this.lineShow3 = true;
        this.itemShow3 = true;
        this.lineShow4 = true;
        this.itemShow4 = true;
        this.lineShow5 = true;
        this.itemShow5 = true;
        this.lineShow6 = false;
        this.itemShow6 = false;
      } else if (num === 5) {
        this.lineShow1 = true;
        this.itemShow1 = true;
        this.lineShow2 = true;
        this.itemShow2 = true;
        this.lineShow3 = true;
        this.itemShow3 = true;
        this.lineShow4 = true;
        this.itemShow4 = true;
        this.lineShow5 = true;
        this.itemShow5 = true;
        this.lineShow6 = true;
        this.itemShow6 = true;
      }
    },
    // 选择下拉菜单
    handleCommand(itemId) {
      for (var i = 0; i < this.jobInfoList.length; i++) {
        if (this.jobInfoList[i].jobId === itemId) {
          console.log(this.jobInfoList[i]);
          this.jobInfoListItem = this.jobInfoList[i].jobName;
          this.jobId = itemId;
          this.applyId = this.jobInfoList[i].applyId;
          this.getApplyStatusQuery();
        }
      }
    },
    // 状态修改（两个按钮）
    medicalApplyStatusUpdate(num) {
      var fakeInfo = {
        applyId: this.applyId,
        applyStatus: num
      };
      applyMedicalStatusUpdate(fakeInfo)
        .then(res => {
          console.log("--------修改状态（两个按钮）--------");
          console.log(res);
          if (res.data.code === "A0000") {
            this.$message({
              message: this.$t("success"),
              type: "success"
            });
            this.getApplyStatusQuery();
          } else {
            this.$message.error(this.$t("fail"));
          }
        })
        .catch(res => {
          console.log("--------修改状态（两个按钮）--------");
          console.log(res);
        });
    }
  }
};
</script>
<style scoped>
.main-css {
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
}

.top-title {
  min-height: 40px;
  min-width: 550px;
  /* overflow-x: auto; */
  display: flex;
  flex-wrap: wrap;
  /*justify-content: center;*/
  align-content: center;
}

.top-name {
  padding: 0 40px;
  height: 24px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 4px;
  text-align: center;
  line-height: 22px;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: -0.02em;
  color: #686868;
  margin-top: 10px;
  float: left;
}

.case-num {
  padding: 0 5px;
  height: 24px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 4px;
  text-align: center;
  line-height: 22px;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  letter-spacing: -0.02em;
  color: #686868;
  margin-top: 10px;
  float: right;
  margin-left: 5px;
}

.main-box {
  width: calc(100vh - 266px);
  min-width: 1080px;
  margin: 0 auto;
  flex: 1;
  padding-top: 10px;
  display: flex;
  overflow: hidden;
}

.left-box {
  width: 48%;
  min-width: 550px;
  height: max-content;
  overflow: hidden;
  padding-bottom: 20px;
}

.main-left-box {
  padding-left: 18px;
  height: max-content;
  min-height: 400px;
  overflow-x: hidden;
  overflow-y: auto;
}

.left-button {
  width: 100%;
  height: 41px;
}

.left-button-1 {
  width: 85px;
  height: 40px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #51abff;
  float: left;
  margin-left: 50px;
  cursor: pointer;
}

.left-button-2 {
  width: 152px;
  height: 40px;
  background: #fc630c;
  border-radius: 4px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  float: right;
  margin-left: 5px;
}

.case-name {
  height: 55px;
  width: 100%;
}

.case-name .title {
  width: 440px;
  height: 25px;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  color: #686868;
  border-bottom: 1px solid #686868;
}

.case-name .title-name {
  height: 30px;
  width: 440px;
  font-weight: 500;
  font-size: 18px;
  line-height: 30px;
  color: #686868;
}

.case-img {
  margin-top: 20px;
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: space-between;
}

.case-img img {
  margin-left: -1px;
  width: 135px;
  height: 122px;
}

.label {
  width: 100%;
  height: 26px;
  margin-top: 20px;
}

.label-box {
  padding: 0 5px;
  background: #b2b2b2;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #ffffff;
  float: left;
  margin-right: 20px;
}

.label-box span {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  line-height: 14px;
  color: #b2b2b2;
  text-align: center;
  margin-left: 10px;
  cursor: pointer;
}

.left-button {
  width: 100%;
  height: 41px;
}

.inline-left {
  width: 200px;
  height: 130px;
  margin-right: 45px;
  float: left;
  /*background: #51abff;*/
}
.inline-left .inline-left-title-main-right {
  width: 70%;
}

.inline-right {
  width: 240px;
  height: 130px;
  margin-right: 20px;
  float: left;
}

.inline-left-title {
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-weight: 700;
  font-size: 14px;
  color: #686868;
  border-bottom: 1px solid #686868;
  /*background:yellow;*/
}

.inline-left-title-main {
  display: flex;
  white-space: nowrap;
  height: 30px;
  line-height: 30px;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.25px;
  color: #686868;
  /*background: peru;*/
}

.inline-left-title-main-right {
  width: 80%;
  min-width: 140px;
  height: 30px;
  line-height: 30px;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
  margin-left: 10px;
  float: right;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.inline-left-title-main-right-long {
  width: 82%;
  height: 30px;
  font-weight: 400;
  font-size: 12px;
  letter-spacing: 0.2px;
  color: #686868;
  float: right;
}


.inline-left-title {
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-weight: 700;
  font-size: 14px;
  color: #686868;
  border-bottom: 1px solid #686868;
  /*background:yellow;*/
}

.inline-left-title-main-right {
  width: 70%;
  min-width: 140px;
  height: 30px;
  line-height: 30px;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
  margin-left: 10px;
  float: right;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.inline-left-title-main-right-long {
  width: 82%;
  height: 30px;
  font-weight: 400;
  font-size: 12px;
  letter-spacing: 0.2px;
  color: #686868;
  float: right;
}
.inline-box {
  height: 140px;
  width: 100%;
  margin-top: 10px;
}

.inline-box {
  width: 100%;
  margin-top: 10px;
  display: flex;
}

.inline-log-box {
  margin-top: 10px;
  width: 93%;
  height: 120px;
}

.long-box-title {
  height: max-content;
  line-height: 30px;
  font-weight: 700;
  font-size: 14px;
  color: #686868;
  border-bottom: 1px solid #686868;
}

.long-box-main {
  width: 485px;
  font-weight: 400;
  min-height: 60px;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #686868;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
}

/* .right-box {
    width: 600px;
    height: 700px;
    float: left;
    margin-left: 80px;
  } */

.one-box-left {
  width: 500px;
  height: 150%;
  padding-left: 40px;
  box-sizing: border-box;
  display: flex;
  justify-content: left;
}

.one-box-left1 {
  width: 200px;
  height: 70%;
  padding-left: 20px;
  padding-top: 5px;
  box-sizing: border-box;
  display: flex;
  justify-content: left;
}

.one-box-left2 {
  width: 600px;
  height: 100px;
  background: #ffffff;
  border-radius: 4px;
  margin: auto;
}

.one-box-left-line1 {
  width: 80%;
  height: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.one-box-left-line2 {
  width: 80%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.one-box-left-line3 {
  width: 80%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.one-box-left-line4 {
  width: 80%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.one-box-left-line-smallleft {
  width: 20%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  /* or 171% */
  display: flex;
  align-items: center;
  /* 灰色字体 */
  color: #686868;
}

.one-box-left-line-smallright {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  /* or 143% */

  display: flex;
  align-items: center;

  /* 灰色字体 */

  color: #686868;
}

.label-box-active {
  float: left;
  height: 24px;
  padding: 0 5px;
  line-height: 24px;
  background: #51abff;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
  overflow: hidden;
  margin-right: 20px;
}

.label-box-active span {
  height: 13px;
  width: 13px;
  background: #fff;
  border-radius: 50%;
  line-height: 13px;
  text-align: center;
  margin-left: 10px;
  display: inline-block;
  color: #b2b2b2;
}

.label-box span {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  line-height: 14px;
  color: #b2b2b2;
  text-align: center;
  margin-left: 10px;
  cursor: pointer;
}

.right-box {
  width: 50%;
  min-width: 500px;
  float: left;
  /* margin-left: 80px; */
}

.right-box /deep/ .chat-box {
  height: 450px;
  border: 0;
  box-shadow: unset;
}

.right-box /deep/ .title-main {
  height: 320px;
}

.info-box {
  width: 530px;
  height: 60px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  margin-top: 10px;
  position: relative;
}

.el-dropdown-class-normal {
  height: 60px;
  width: 530px;
}

.el-dropdown-link-normal {
  display: inline-block;
  height: 56px;
  width: 526px;
  line-height: 56px;
  padding: 0 40px 0px 15px;
  text-align: center;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  box-sizing: border-box;
}

.info-box-span {
  position: absolute;
  top: -12px;
  left: 15px;
  display: inline-block;
  height: 24px;
  padding: 0 5px;
  background: #ffffff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}

.info-img-css1 {
  border-radius: 50%;
}

.info-img-css2 {
  position: absolute;
  top: 20px;
  right: 40px;
}

.schedule-box {
  width: 530px;
  height: 200px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  margin-top: 10px;
  position: relative;
}

.box-title {
  margin-top: 10px;
  padding-left: 20px;
  letter-spacing: 0.25px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  display: flex;
  align-items: center;
  color: #686868;
}

.info-box-title {
  margin-top: 20px;
  padding-left: 20px;
  letter-spacing: 0.25px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  display: flex;
  align-items: center;
  color: #686868;
  text-align: center;
}

.schedule-box span {
  position: absolute;
  top: -12px;
  left: 15px;
  display: inline-block;
  height: 24px;
  padding: 0 5px;
  background: #ffffff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}

.chat-box-css {
  width: 530px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  margin-top: 10px;
  position: relative;
  margin-bottom: 60px;
  padding-bottom: 20px;
}

.chat-box-css span {
  position: absolute;
  top: -12px;
  left: 15px;
  display: inline-block;
  height: 24px;
  padding: 0 5px;
  background: #ffffff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}

.chat-box-css /deep/ .search .el-input__inner {
  background: transparent;
}

.chat-box-css /deep/ .send-message {
  height: 60px;
}

.chat-box-css /deep/ .send-message .el-input__inner {
  border-radius: 0;
  border-bottom: 1px solid #51abff;
}

.progress-bar {
  height: 20px;
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.line-between-active {
  height: 2px;
  width: 40px;
  background: #51abff;
}

.line-between-normal {
  height: 2px;
  width: 40px;
  background: #dce3e9;
}

.progress-item-active {
  width: 20px;
  height: 20px;
  line-height: 20px;
  background: #51abff;
  border-radius: 50%;
  text-align: center;
  font-weight: 400;
  font-size: 13px;
  color: #ffffff;
  position: relative;
}

.progress-title {
  width: 65.33px;
  height: 20px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.25px;
  color: #252a31;
  flex: none;
  order: 0;
  flex-grow: 1;
  margin-top: 36px;
  margin-left: -45px;
  display: inline-block;
  background: pink;
}

.progress-item-active-big {
  width: 23px;
  height: 23px;
  line-height: 20px;
  background: #51abff;
  border-radius: 50%;
  text-align: center;
  font-weight: 400;
  font-size: 13px;
  color: #ffffff;
  position: relative;
}

.line-center-active {
  width: 60px;
  height: 2px;
  background: #51abff;
}

.line-center-normal {
  width: 60px;
  height: 2px;
  background: #dce3e9;
}

.progress-item-normal {
  width: 20px;
  height: 20px;
  line-height: 20px;
  background: #dce3e9;
  border-radius: 50%;
  text-align: center;
  font-weight: 400;
  font-size: 13px;
  color: #252a31;
  position: relative;
}

.input-box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px 6px;
  gap: 10px;
  position: absolute;
  /* width: 221px; */
  height: 32px;
  width: 450px;
  top: 80px;
  left: 50%;
  margin-left: -225px;
  background: #fc630c;
  border-radius: 8px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #ffffff;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.input-box-css {
  width: 100%;
  height: 35px;
  margin-top: 40px;
}

.button-box {
  height: 24px;
  display: flex;
  justify-content: center;
  align-content: center;
  position: absolute;
  bottom: 15px;
  right: 0;
}

.button-css1 {
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #51abff;
  margin-right: 25px;
  cursor: pointer;
  width: 50px;
  height: 24px;
  font-family: "Poppins";
  font-style: normal;
  line-height: 18px;
  align-items: center;
  text-align: center;
}

.button-css2 {
  background: #51abff;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #fafafa;
  margin-right: 25px;
  cursor: pointer;
  width: 70px;
  height: 24px;
  font-family: "Poppins";
  font-style: normal;
  line-height: 18px;
  align-items: center;
  text-align: center;
}
 .main-button {
   width: 500px;
   height: 50px;
   text-align: center;
   /*margin-left: 455px;*/
   margin-left: 30%;
  margin-bottom: 80px;

 }

 .main-button button {
   cursor: pointer;
   height: 40px;
   width: 152px;
   background: #fc630c;
   border-radius: 4px;
   font-family: "Poppins";
   font-style: normal;
   font-weight: 500;
   font-size: 14px;
   color: #ffffff;
 }
</style>



// WEBPACK FOOTER //
// src/pages/detailsOfCaseProgressInMedicalInstitutions/index.vue